<template>
  <ul class="tabs" v-if="tabs">
    <li class="tab" v-for="tab in tabs" @click="currentTab = tab.id" >
      <a v-if="isHref" :href="'#'+tab.id">{{ tab.name }}</a>
      <template v-else :href="'#'+tab.id">{{ tab.name }}</template>
    </li>
  </ul>
</template>

<script>

    export default {
        props: {
            tabs: Array,
            value: Number,
            isHref: {
              type: Boolean,
              default: false
            }
        },
        data() {
            return {
                currentTab: this.value
            };
        },
        components: {},
        mounted() {
            if(this.tabs && !this.currentTab){
                this.currentTab = this.tabs[0].id
            } else {
                for(let i in this.tabs){
                    if(this.currentTab == this.tabs[i].id){
                        this.currentTab = this.tabs[i].id
                    }
                }
            }
        },
        methods: {

        },
        watch: {
            currentTab(val) {
                this.$emit('input', val);
            }
        }
    }
</script>

<style lang="scss">

  .tabs{
    border-bottom: 1px solid #E0E8F0;
    box-sizing: border-box;
    display: flex;
    padding-left: 0!important;

    .tab{
      font-size: 22px;
      line-height: 42px;
      color: #B4BDC6;
      display: inline-block;
      padding: 0 16px;
      border-bottom: 4px solid transparent;
      -webkit-transition: all .2s ease;
      -moz-transition: all .2s ease;
      -ms-transition: all .2s ease;
      -o-transition: all .2s ease;
      transition: all .2s ease;
      position: relative;
      top: 1px;
      a{
        text-decoration: none;
        color: #B4BDC6;
      }
      &:hover{
        cursor: pointer;
      }

      &.tab-active{

        border-bottom: 1px solid #29B2FF;
        color: #29B2FF;
        a{
          color: #29B2FF;
        }

      }
    }
  }
</style>
